import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const SpellCheck: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'm6 16 6-12 6 12' }],
    ['path', { d: 'M8 12h8' }],
    ['path', { d: 'm16 20 2 2 4-4' }],
  ],
];

export default SpellCheck;
